import type { NestedI18nObject } from '../../utils';

const crossborder: NestedI18nObject = {
  // Cross-border E-commerce Login Page
  login: {
    title: 'CrossBorder ERP',
    subtitle: 'Global Cross-border E-commerce Management Platform',
    welcome: 'Welcome to CrossBorder ERP!',
    email: {
      placeholder: 'Email Address',
      required: 'Please enter email address',
      invalid: 'Please enter a valid email address',
    },
    password: {
      placeholder: 'Password',
      required: 'Please enter password',
      min: 'Password must be at least 8 characters',
    },
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    loginButton: 'Login',
    loginProgress: 'Logging in...',
    registerText: 'Don\'t have an account?',
    registerLink: 'Sign up now',
    success: 'Login successful, welcome to CrossBorder ERP!',
    failure: 'Login failed, please check email and password',
    failureTitle: 'Login Failed',
    failureDesc: 'Incorrect email or password, please try again',
  },

  // Features
  features: {
    amazon: 'Amazon Integration',
    warehouse: 'Smart Warehouse',
    orders: 'Order Management',
    global: 'Global Markets',
  },

  // Info Panel
  panel: {
    title: 'Professional Cross-border E-commerce Solutions',
    multiplatform: {
      title: 'Multi-platform Integration',
      desc: 'Support for Amazon, eBay and other major e-commerce platforms',
    },
    global: {
      title: 'Global Support',
      desc: 'Multi-language, multi-currency, multi-timezone management',
    },
    inventory: {
      title: 'Smart Inventory',
      desc: 'Real-time inventory tracking with automatic restock alerts',
    },
  },

  // Footer Links
  footer: {
    about: 'About Us',
    help: 'Help Center',
    privacy: 'Privacy Policy',
  },
};

export default crossborder;
